import { render, staticRenderFns } from "./BindGoodsHeader.vue?vue&type=template&id=9cf32aa0&scoped=true&"
import script from "./BindGoodsHeader.vue?vue&type=script&lang=ts&"
export * from "./BindGoodsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BindGoodsHeader.vue?vue&type=style&index=0&id=9cf32aa0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf32aa0",
  null
  
)

export default component.exports